import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { DetalleSistemaUnidadSectorGrupoDTO } from './types'

const getEndpoint = (url = '') => `reportes${url}`

export const HttpReportes = {
    getDetalleSistemaUnidadSectorGrupo: (): Promise<DetalleSistemaUnidadSectorGrupoDTO[]> => {
        return HttpAxiosRequest.get(getEndpoint('/detalle-sistema-unidad-sector-grupo'))
    }
}
